import { Instagram } from "lucide-react";
import { FadeUp, Stagger, StaggerItem } from "@/components/motion/Reveal";
import { BUSINESS, INSTAGRAM_TILES } from "@/data/site";

export default function InstagramSection() {
  return (
    <section className="bg-beige/40 py-20 sm:py-28" data-testid="instagram-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="text-center mb-12">
          <FadeUp>
            <p className="eyebrow text-gold mb-4">Sosyal</p>
          </FadeUp>
          <FadeUp delay={0.05}>
            <h2 className="font-serif text-espresso text-4xl sm:text-5xl lg:text-6xl">
              Salonumuzdan <span className="italic">Son Dokunuşlar</span>
            </h2>
          </FadeUp>
        </div>

        <Stagger className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4">
          {INSTAGRAM_TILES.map((src, i) => (
            <StaggerItem key={i}>
              <a
                href={BUSINESS.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`instagram-tile-${i}`}
                className="img-zoom group relative block aspect-square overflow-hidden rounded-xl bg-espresso"
              >
                <img
                  src={src}
                  alt="Hülya Suna Beauty Instagram paylaşımı — yer tutucu görsel"
                  loading="lazy"
                  className="h-full w-full object-cover opacity-95 transition-opacity group-hover:opacity-100"
                />
                <span className="absolute inset-0 flex items-center justify-center bg-espresso/40 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <Instagram size={24} className="text-ivory" />
                </span>
              </a>
            </StaggerItem>
          ))}
        </Stagger>

        <FadeUp delay={0.1}>
          <div className="mt-12 text-center">
            <a
              href={BUSINESS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="instagram-follow-button"
              className="inline-flex items-center gap-2 rounded-full border border-espresso/25 px-8 py-4 text-espresso text-sm font-medium transition-colors duration-300 hover:bg-espresso hover:text-ivory"
            >
              <Instagram size={18} />
              Instagram’da Takip Et — {BUSINESS.instagramHandle}
            </a>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
